import * as React from 'react';
import renderHTML from 'react-render-html';
import { thousandNumberFormat } from '../../Common/Helpers';
import { HomeStateInfo } from "./../../../interface/FactSheetInterface"

interface Props {
    stayed_bullet: string;
}


const DoctorBullets = ({ stayed_bullet }: Props) => {
    const doctor = require('../../../images/doctor.jpg');
    if (stayed_bullet !== undefined)
        return (
            <div className="row" style={{ marginTop: "20px", marginBottom: "20px" }}>
                <div className="col-md-7">
                    {renderHTML(stayed_bullet)}
                </div>
                <div className="col-md-5">
                    <img height='200px' src={String(doctor)} />
                </div>
            </div>
        );
    return (<div></div>)
}

export default DoctorBullets;